import { FormApiAvancement } from 'form-api';
export type AvancementSociete = FormApiAvancement.AvancementSociete;
export const AvancementStatus = FormApiAvancement.AvancementStatus;
export const avancementControllerUrl = 'avancement';

export type AvancementResponseType = {
  [siren: string]: AvancementSociete;
};
